export const BUTTON_STYLES = {
    // 모달 확인 버튼 (Button1, 80×32)
    modalPrimary: {
        onlyText: true,
        width: "80px",
        height: "32px",
        bgColor: "var(--color-Button1)",
        hoverBgColor: "var(--color-ButtonHover1)",
        fontColor: "var(--color-White)",
    },
    // 모달/보조/취소 버튼 (Button4, 80×32)
    modalSecondary: {
        onlyText: true,
        width: "80px",
        height: "32px",
        bgColor: "var(--color-Button4)",
        hoverBgColor: "var(--color-ButtonHover4)",
        fontColor: "var(--color-Black)",
        fontWeight: "400",
    },
    // 페이지네이션 아이콘 버튼
    paginationIcon: {
        onlyIcon: true,
        bgColor: "transparent",
        hoverBgColor: "var(--color-ButtonHover4)",
        transparentDisabled: true,
    },
    // 페이지네이션 숫자 버튼
    paginationNumber: {
        onlyText: true,
        margin: "0 4px",
        height: "24px",
        width: "auto",
        minWidth: "24px",
    },
    // 투명 배경 텍스트 링크 버튼 (로그인/회원가입 등 보조 링크)
    linkButton: {
        onlyText: true,
        width: "fit-content",
        height: "fit-content",
        bgColor: "transparent",
        hoverBgColor: "transparent",
        fontColor: "var(--color-Grey1)",
        fontWeight: "400",
        fontSize: "small",
        hoverTextStyle: "color: var(--color-Key); text-decoration: underline;",
    },
    // 주요 액션 버튼 (Button2 계열, width/height는 사용처에서 지정)
    actionPrimary: {
        bgColor: "var(--color-Button2)",
        hoverBgColor: "var(--color-ButtonHover2)",
        fontColor: "var(--color-White)",
    },
    // 주요 액션 텍스트 버튼
    actionPrimaryText: {
        onlyText: true,
        bgColor: "var(--color-Button2)",
        hoverBgColor: "var(--color-ButtonHover2)",
        fontColor: "var(--color-White)",
    },
    // 경고/삭제 등 위험 액션 버튼
    dangerPrimary: {
        onlyText: true,
        height: "32px",
        bgColor: "var(--color-Warn)",
        hoverBgColor: "var(--color-WarnHover)",
        fontColor: "var(--color-White)",
    },
    // 소형 액션 버튼 (Button3 계열, width/height는 사용처에서 지정)
    compactAction: {
        onlyText: true,
        bgColor: "var(--color-Button3)",
        hoverBgColor: "var(--color-ButtonHover3)",
        fontColor: "var(--color-White)",
    },
    // 작은 pill 형태의 링크/외부 이동 액션
    chipAction: {
        onlyText: true,
        height: "18px",
        padding: "0 4px",
        borderRadius: "4px",
        bgColor: "var(--color-Button3)",
        hoverBgColor: "var(--color-ButtonHover3)",
        fontColor: "var(--color-White)",
        fontSize: "xsmall",
    },
    // 아이콘 전용 ghost 버튼 (투명 배경, hover 시 ButtonHover4)
    iconGhost: {
        onlyIcon: true,
        bgColor: "transparent",
        hoverBgColor: "var(--color-ButtonHover4)",
    },
    // Button4 배경의 보조 아이콘 버튼
    iconSecondary: {
        onlyIcon: true,
        bgColor: "var(--color-Button4)",
        hoverBgColor: "var(--color-ButtonHover4)",
    },
    // 흰 배경의 표면 아이콘 버튼
    iconSurface: {
        onlyIcon: true,
        bgColor: "var(--color-White)",
        hoverBgColor: "var(--color-ButtonHover4)",
    },
    // hover 효과가 없는 흰 배경 아이콘 버튼
    iconSurfaceStatic: {
        onlyIcon: true,
        bgColor: "var(--color-White)",
        hoverBgColor: "transparent",
    },
    // hover 효과가 없는 투명 아이콘 버튼
    iconPlain: {
        onlyIcon: true,
        bgColor: "transparent",
        hoverBgColor: "transparent",
        transparentDisabled: true,
    },
    // 드롭다운/검색 기록 등 약한 강조의 아이콘 버튼
    iconSubtleGhost: {
        onlyIcon: true,
        bgColor: "transparent",
        hoverBgColor: "var(--color-ButtonHover5)",
    },
    // 모바일 전체폭 메뉴 버튼
    menuItemText: {
        onlyText: true,
        width: "100%",
        height: "56px",
        padding: "0 16px",
        bgColor: "transparent",
        hoverBgColor: "var(--color-ButtonHover4)",
        borderRadius: "0",
        fontSize: "regular",
        fontWeight: "600",
        fontColor: "var(--color-Black)",
    },
    // 드롭다운/팝오버 메뉴 항목 버튼
    dropdownItemText: {
        onlyText: true,
        width: "100%",
        bgColor: "transparent",
        hoverBgColor: "var(--color-ButtonHover5)",
        fontColor: "var(--color-Black)",
    },
};
